import styled from 'styled-components';

const StyledCommonButtonContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default StyledCommonButtonContent;
